import React, { useState } from "react";
import ssoImg1 from "./../../../../assets/images/shipping-safty.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/mrcc-2.png"; // Adjust the path as necessary
import horizon1 from './../../../../assets/images/horizontal-img-1.png';
import pilotIcon from "./../../../../assets/images/user-pilot-tie.svg"; // Adjust the path as necessary
import scaleIcon from "./../../../../assets/images/scale-balanced.svg"; // Adjust the path as necessary

import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';

function ShippingSafetyOverviewTab() {
      const cardData = [
    {
      icon: pilotIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Executes a Maritime Assistance Service (MAS)",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Manage the reception and dissemination of Maritime Security information",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "ISPS code",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Acts as the SA Navigational Communications Search and Rescue (NCSR) agency (IMO)  and the COSPAS SARSAT agency (ICAO)",
  },
 
  
    
    
    
  
    
  ];
  
 
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SHIPPING SAFETY
        <span className="text-orange-ef3e33 font-400"> overview </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="mb-3 text-primary-color">
            The Centre adheres to various national and international standards
            (IMO Standards) by conducting Surveys of Ships (all South African
            Registered Convention Ships and Non- Convention Ships.
          </p>

          <p className="mb-3 text-primary-color">
            The surveys are conducted by SAMSA Surveyors and SAMSA Approved
            Surveyors.
          </p>

          <p className="font-18 font-900 mb-3">
            <span className="d-block text-primary-green" style={{ fontSize: '24px', fontWeight: 800 }}>The Centre</span>
            {/* The Centre for Ships is responsible for the Administration of the; */}
          </p>

          <div className="row g-4">
            <div className="col-xl-6 col-md-6 col-sm-6">
              <div className="gray-card-wrap">
                <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={pilotIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color">
                    Executes a Maritime Assistance Service (MAS)
                  </div>

                  <div className="card-share">
                    {/* <button type="button" className="btn-share border-0">
                      <i className="bi bi-share"></i>
                    </button> */}
                    <ul>
                      <li>
                        <a href="#">
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaTwitter />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaLinkedinIn />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaInstagram />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaYoutube />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-6 col-sm-6">
              <div className="gray-card-wrap">
                <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={scaleIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color">
                    Manage the reception and dissemination of Maritime Security
                    information
                  </div>

                  <div className="card-share">
                    {/* <button type="button" className="btn-share border-0">
                      <i className="bi bi-share"></i>
                    </button> */}
                    <ul>
                      <li>
                        <a href="#">
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaTwitter />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaLinkedinIn />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaInstagram />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaYoutube />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
        <div className="col-12">
          <div className="row g-4">
            {cardData.map((card, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6" key={index}>
                <div className="gray-card-wrap">
                  {/* <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">
                      {card.cardDescription}
                    </div>

                    <div className="card-share">
                      <button
                        type="button"
                        className="btn-share border-0"
                      >
                        <i className="bi bi-share"></i>
                      </button>
                      <ul

                      >
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-12">
          <div className="row g-4 align-items-end">
            <div className="col-lg">
              <div className="gray-card-wrap">
                {/* <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={pilotIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color">
                    Executes a Maritime Assistance Service (MAS)
                  </div>

                  <div className="card-share">
                    <button type="button" className="btn-share border-0">
                      <i className="bi bi-share"></i>
                    </button>
                    <ul>
                      <li>
                        <a href="#">
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaTwitter />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaLinkedinIn />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaInstagram />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaYoutube />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className="col-lg-auto">
              <img src={horizon1} className="img-fluid w-100 rounded-1" alt="" />
            </div> */}
          </div>
        </div>

        {/* <div className="col-12">
          <div className="row g-4">
            {cardData.map((card, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6" key={index}>
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">
                      {card.cardDescription}
                    </div>

                    <div className="card-share">
                      <button
                        type="button"
                        className="btn-share border-0"
                      >
                        <i className="bi bi-share"></i>
                      </button>
                      <ul
                  
                      >
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        <div className="col-12">
          <div className="row g-4 align-items-end">
            <div className="col-lg">
              <div className="gray-card-wrap">
                {/* <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={pilotIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color">
                    Executes a Maritime Assistance Service (MAS)
                  </div>

                  <div className="card-share">
                    <button type="button" className="btn-share border-0">
                      <i className="bi bi-share"></i>
                    </button>
                    <ul>
                      <li>
                        <a href="#">
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaTwitter />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaLinkedinIn />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaInstagram />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaYoutube />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className="col-lg-auto">
              <img src={horizon1} className="img-fluid w-100 rounded-1" alt="" />
            </div> */}
          </div>
        </div>

       
      </div>
    </>
  );
}

export default ShippingSafetyOverviewTab;